import { isTodoDisplayed } from 'shared/lib/todoVisibility';

const tableOrder = ['air_export', 'ocean_export', 'ftl_ltl', 'air_import', 'ocean_import'];

const todoKeyOrder = [
    'il_comment',
    'delivery_appointment',
    'prepull_appointment',
    'pick_appointment',
    'trans_load_status',
    'move_appointment',
    'empty_status',
    'return_status',
    'gate_status',
    'load_status',
    'receive_status',
    'departure_status',
    'transshipment_status',
    'demurrage',
    'air_freight',
    'import_service_fee',
    'booking_confirmation',
    'stages',
    'aes_itn',
    'shipping_instruction',
    'dg_hazmat',
    'etd',
    'etd',
    'eta',
    'incoterm',
    'intermodal',
    'proof_link',
    'pickup_number',
    'arranging_delivery',
    'arranging_pickup',
    'arranging_to',
    'pre_alert',
    'isf',
    'delivery_order',
    'arrival_notice',
    'customs_hold',
    'customs',
    'ocean_freight',
    'mbl_release',
    'hbl_release',
    'pierpass',
    'empty',
    'proof',
    'invoice',
    'crdr',
    'client_closure',
    'case_closure',
];

function getTablePriority(tablename = '') {
    const found = tableOrder.findIndex((key) => tablename.includes(key));
    return found === -1 ? Infinity : found;
}

function getTodoKeyPriority(todoKey = '') {
    const found = todoKeyOrder.indexOf(todoKey);
    return found === -1 ? Infinity : found;
}

export default function todoSortingHandler(data) {
    return [...data]
        .filter(isTodoDisplayed)
        .sort((a, b) => {
            // 1. status = true goes last
            if (a.status === true && b.status === false) return 1;
            if (a.status === false && b.status === true) return -1;

            // 2. intensity priority (only if both status === false)
            if (a.status === false && b.status === false) {
                if (a.intensity === true && b.intensity === false) return -1;
                if (a.intensity === false && b.intensity === true) return 1;

                // 3. todo_key priority
                const aKeyPriority = getTodoKeyPriority(a.todo_key);
                const bKeyPriority = getTodoKeyPriority(b.todo_key);
                if (aKeyPriority !== bKeyPriority) return aKeyPriority - bKeyPriority;

                // 4. tableName priority
                const aTablePriority = getTablePriority(a.tablename);
                const bTablePriority = getTablePriority(b.tablename);
                if (aTablePriority !== bTablePriority) return aTablePriority - bTablePriority;

                // 5. il_opus_reference_id priority (group same reference together)
                const aRefId = a.il_opus_reference_id ?? '';
                const bRefId = b.il_opus_reference_id ?? '';
                if (aRefId !== bRefId) return String(aRefId).localeCompare(String(bRefId));
            }
            return 0;
        });
}
